import { Validated } from '../model/general';
import { DirectionFilterNames } from '../utils/enums';

export interface LogCriteria {
    timeDetails?: TimeDetails;
    direction?: DirectionFilterNames;
    url?: string;
    sourceIp?: string;
    destIp?: string;
    dport?: string;
    action?: string;
    application?: string;
    threatTypes?: string[];
    rule?: string;
}

export interface ActivityCriteria {
    timeDetails?: TimeDetails;
    activity?: string[];
    policyVersion?: number[];
    user?: string;
    clientIp?: string;
}

export interface CriteriaConfig<T> extends Validated<T> {
    header: string;
    width: string | number;
    type: LogFilterType;
    options?: { value: string; label: string }[];
    defaultValue: string;
    showSearch?: boolean;
    showAllOption?: boolean;
    allowedDaysAgo?: number;
    disabled?: boolean; // Optional property for disabling fields
}

export interface TimeDetails {
    timeRange?: string;
    startDate?: Date;
    endDate?: Date;
}

export interface ActivityLogDownloadInfo {
    logsFileType: any;
    timeZoneId: string;
    auditFilterRequest: {
        fromDateTime: Date | undefined;
        toDateTime: Date | undefined;
        activity: string[] | undefined;
        policyVersion: number[],
        user: string | undefined,
        clientIp: string | undefined
    };
}

export interface LogDownloadInfo {
    logsFileType: any;
    description: string;
    logDetails: {
        logType: string;
        fromDateTime: Date | undefined;
        toDateTime: Date | undefined;
        direction: string | undefined;
        sourceIp: string | undefined;
        destIp: string | undefined;
        dport: string | undefined;
        action: string | undefined;
    };
}

export enum LogFilterType {
    INPUT = 'Input',
    INPUT_NUMBER = 'InputNumber',
    TIME = 'Time',
    DROP_DOWN = 'Dropdown',
    MULTISELECT = 'MultiSelect',
}